import { errorDescriptionFromResponse } from '../../utils/error';
import ClapprUtils from '../../utils/clappr';
import HighlightCapturePlugin from '../../../player/highlight-capture-plugin';

// angular.component definition for a modified boxcast-player that
// supports a highlight capture component.
var playerWithHighlightCapture = {
  bindings: {
    channelId: '<',
    options: '<',
    broadcast: '<',
    onOpenHighlightPreview: '=',
    onNewHighlightCaptured: '=',
    onOpenLowLatencyPreview: '=',
    parentVm: '<',
  },
  template: `
    <boxcast-player ng-if="vm.__readyToLoadPlayer"
                    channel-id="vm.channelId"
                    options="vm.options"></boxcast-player>
  `,
  controllerAs: 'vm',
  controller: PlayerWithHighlightCaptureController,
};

function PlayerWithHighlightCaptureController(
  $scope,
  $element,
  $attrs,
  $timeout,
  $rootScope,
  $sce,
  toaster,
  Highlight
) {
  'ngInject';

  const { account, user } = $rootScope;
  this.FeatureFlags = account.feature_flags;
  this.account = account;
  this.$sce = $sce;
  this.toaster = toaster;
  this.Highlight = Highlight;

  /* the following are provided automagically by angular.component bindings...
  this.channelId = channelId;
  this.options = options;
  this.onOpenHighlightPreview = onOpenHighlightPreview;
  this.onNewHighlightCaptured = onNewHighlightCaptured;
  this.onOpenLowLatencyPreview = onOpenLowLatencyPreview;
  this.parentVm = parentVm;
  */

  const watchFn = () => {
    if (!this.channelId) return;
    if (!this.options.ticketId) return;
    if (
      this.FeatureFlags.highlights &&
      this.broadcast.recording_requested !== false &&
      user.can('create', 'broadcast/*:highlight')
    ) {
      var origOnLoadPlayer = this.options.onLoadPlayer || function () {};
      this.options.onLoadPlayer = (player) => {
        this.clapprUtils = new ClapprUtils(player);
        origOnLoadPlayer(player);
      };
      this.options.clapprPlugins = [HighlightCapturePlugin];
      this.options.clapprConfig = {
        highlightCapturePlugin: {
          onPreview: (data) => $timeout(() => this.onHighlightCapturePreview(data), 0),
          onSave: (data) => $timeout(() => this.onHighlightCaptureSave(data), 0),
        },
      };
    }
    this.__readyToLoadPlayer = true;
  };
  $scope.$watch(() => this.channelId, watchFn);
  $scope.$watch(() => this.options, watchFn, true);

  this._unpackAndValidateHighlightData = (data) => {
    var highlight = {
      name: data.name,
      start_seconds:
        data.start_seconds || this.clapprUtils.getMediaAbsoluteTimeForTime(data.start),
      stop_seconds:
        data.stop_seconds || this.clapprUtils.getMediaAbsoluteTimeForTime(data.end),
    };
    if (highlight.start_seconds === null || highlight.stop_seconds === null) {
      console.warn('error getting start/stop seconds', data, highlight);
      this.toaster.pop(
        'warning',
        'Unable to generate highlight. Please check the selected time and duration and then try again.'
      );
      return;
    }
    return highlight;
  };

  this.onHighlightCapturePreview = (data) => {
    var highlight = this._unpackAndValidateHighlightData(data);
    if (!highlight) return;
    this.onOpenHighlightPreview
      .bind(this.parentVm)(highlight, true)
      .result.then((result) => {
        console.log('saving with original data', data, 'and updates from preview', result);
        // User opted to save the highlight from within the preview
        this.onHighlightCaptureSave(angular.extend({}, data, result));
      });
  };

  this.onHighlightCaptureSave = (data) => {
    var highlight = this._unpackAndValidateHighlightData(data);
    if (!highlight) return;
    if (!highlight.name) {
      this.toaster.pop('warning', 'Please provide a name for the highlight before saving.');
      return;
    }
    this.Highlight.create({ broadcastId: this.broadcast.id }, highlight)
      .$promise.then(() => {
        this.onNewHighlightCaptured.bind(this.parentVm)();
        data.fnClose();
      })
      .catch((err) => {
        console.error(err);
        this.toaster.pop(
          'warning',
          `The highlight could not be created: ${errorDescriptionFromResponse(err)}`
        );
      });
  };

  this.openLowLatencyPreview = () => {
    this.onOpenLowLatencyPreview.bind(this.parentVm)();
  };
}

export default playerWithHighlightCapture;



// WEBPACK FOOTER //
// ./app/pages/events/player-with-highlight-capture.js